import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

const valueFirstChoicesStyles: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#4B3C6A]',
  COMMONS_FOOTER_BG: 'bg-[#4B3C6A]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#4B3C6A] hover:border-[#4B3C6A] hover:bg-[#4B3C6A] hover:text-white text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#4B3C6A]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#e3daf6]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#4B3C6A]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#4B3C6A]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#e3daf6]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#7f65b6] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#4B3C6A] text-[#4B3C6A] [&>svg>path]:stroke-[#4B3C6A] [&>svg>g>path]:stroke-[#4B3C6A] [&>svg>path]:fill-[#4B3C6A] [&>svg>g>path]:fill-[#4B3C6A]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#e3daf6]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#4B3C6A]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#ccb8f6]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#e3daf6]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#ccb8f6]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#4B3C6A] [&>.explore-icon-fill]:!fill-[#ccb8f6] [&>g>.explore-icon-fill]:!fill-[#ccb8f6]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#ccb8f6] [&>.vector-top>path]:fill-[#4B3C6A] [&>.vector-bottom>path]:fill-[#4B3C6A]',

  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#4B3C6A]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#4B3C6A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#4B3C6A] text-[#4B3C6A] [&>svg>path]:stroke-[#4B3C6A] [&>svg>g>path]:stroke-[#4B3C6A] [&>svg>path]:fill-[#4B3C6A] [&>svg>g>path]:fill-[#4B3C6A]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#4B3C6A] text-[#4B3C6A] [&>svg>path]:stroke-[#7f65b6] [&>svg>g>path]:stroke-[#7f65b6] [&>svg>path]:fill-[#7f65b6] [&>svg>g>path]:fill-[#7f65b6]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#4B3C6A]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#4B3C6A]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#4B3C6A]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#4B3C6A]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#4B3C6A]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#ccb8f6] [&>.vector-top>path]:fill-[#4B3C6A] [&>.vector-bottom>path]:fill-[#4B3C6A]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#ccb8f6] [&>circle]:stroke-[#ccb8f6] [&>path]:fill-[#4B3C6A]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#7f65b6] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#7f65b6] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#7f65b6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#7f65b6] [&_path]:fill-[#7f65b6] [&_path]:stroke-[#7f65b6]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#7f65b6]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#7f65b6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#7f65b6]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#7f65b6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#7f65b6]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#ccb8f6]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#ccb8f6]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#ccb8f6]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-black',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#ccb8f6]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#ccb8f6]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#ccb8f6]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#e3daf6]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#e3daf6]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-black',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#e3daf6]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#e3daf6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#e3daf6]',
}

export default valueFirstChoicesStyles
